import { showPage, getUrlParam, isWechat } from "../utils";
import wx from "jweixin-module";

import Swiper from "swiper";
import "swiper/dist/css/swiper.css";

import btn1Active from "../icons/tab1-active.png";
import btn1Deafult from "../icons/tab1-default.png";
import btn2Active from "../icons/tab2-active.png";
import btn2Deafult from "../icons/tab2-default.png";

const _ = window;
// 获取的数据
_.data = {};
_.host = "http://mcdonald.rfthunder.com/88/interface/";
// swiper 实例
_.swiper;

// 点击的索引
_.clickIndex = parseInt(getUrlParam("clickIndex")) || "";

// 页面索引
_.activeIndex = parseInt(getUrlParam("activeIndex")) || 1;

console.log(history);

let wechatShareText = {
  desc: "",
  title: "",
  imgUrl: "",
  url: ""
};

window.onload = function() {
  $("#app").css({ display: "block" });
};
resetPage();

async function getData() {
  await getDatas();
}
getData();

setBroswerInput();

setEvents();

function setBigMapText(
  index = _.clickIndex !== "" ? _.clickIndex : _.data.indexToday
) {
  let channel = _.activeIndex === 1 ? "store" : "delivery";

  let item = _.data[channel][index];

  wechatShareText.title = item.shareTitle;
  wechatShareText.desc = item.shareContent;
  wechatShareText.imgUrl = _.host + item.shareThumb;
  setWxSetting();
}

function setCalendarText() {
  wechatShareText.title = _.data.calendarShareTitle;
  wechatShareText.desc = _.data.calendarShareContent;
  wechatShareText.imgUrl = _.host + _.data.calendarShareThumb;

  setWxSetting();
}

function getDatas() {
  return new Promise(async resolve => {
    let res = await $.ajax({
      method: "GET",
      url: _.host
    });
    _.data = res.data;

    await setSwiperData();

    setTimeout(() => {
      showMask();
    }, 100);

    getImgs();
    resolve();
  });
}

function createSwiperDom(img) {
  return `
    <div class="swiper-slide">
      <img class='swiper-img' src='${_.host + img}'>
      <div class="mask-close">×</div>
    </div>
  `;
}

function setSwiperData() {
  let channel = +_.activeIndex === 1 ? "store" : "delivery";
  console.log(channel);

  $(".swiper-wrapper").empty();

  for (let i = 0; i < _.data[channel].length; i++) {
    let e = _.data[channel][i];
    if (e.isAvailable) {
      $(".swiper-wrapper").append(createSwiperDom(e.popup));
    }
  }
  // setSwiper();

  if (_.swiper) {
    _.swiper.updateSlides();
  } else {
    setSwiper();
  }

  $(".mask-close").click(hideMask);
}

async function getImgs() {
  let data = _.activeIndex === 1 ? _.data.store : _.data.delivery;

  console.log(_.activeIndex);
  console.log(data);

  $(".list-item").remove();

  data.filter((e, index) => {
    let _text = document.createElement("div");
    _text.innerHTML = e.date;
    _text.classList.add("list-item-text");

    let _img = document.createElement("img");
    _img.classList.add("list-item-img");
    _img.src = _.host + e.thumb;

    if (e.isAvailable) {
      _text.classList.add("active");
    }

    let _dom = document.createElement("span");
    _dom.classList.add("list-item");
    _dom.append(_text);
    _dom.append(_img);
    _dom.addEventListener("click", () => {
      _.clickIndex = index;

      if (e.isAvailable) {
        showMask();
      }
      // setHistory();
    });

    $(".list-warpper").append(_dom);

    let today = new Date().getMonth() + 1 + "-" + new Date().getDate();

    if (!window.localStorage.getItem("isOpen" + today)) {
      window.localStorage.setItem("isOpen" + today, true);
      $("#share-mask").css({ display: "flex" });
    }
  });
}

function showMask(
  index = _.clickIndex === "" ? _.data.indexToday : _.clickIndex
) {
  if (!_.swiper) {
    _.inter = setInterval(() => {
      if (_.swiper) {
        _.swiper.slideTo(index);
        clearInterval(_.swiper);
      }
    }, 100);
  } else {
    _.swiper.slideTo(index);
  }
  setBigMapText();

  $(".swiper-container").css({ display: "block" });
}

function hideMask() {
  $(".swiper-container").css({ display: "none" });
  _.clickIndex = "";

  setCalendarText();
  setHistory();
}

function setSwiper() {
  _.swiper = new Swiper(".swiper-container", {
    observer: true,
    observeParents: true,
    on: {
      slideChange: function() {
        _.clickIndex = swiper.realIndex;
        setBigMapText(swiper.realIndex);
        setHistory();
      }
    }
  });
}

function resetPage() {
  let iswx = isWechat();

  if (!iswx) {
    $("#wechat-warpper").css({ display: "flex" });
  }

  showPage($("#page1"));

  // 设置按钮的图片
  setBtn();

  // 设置自适应
  let btnHeight = 107;
  if (window.innerHeight < 1042 + 40 + btnHeight) {
    let scale = (window.innerHeight - btnHeight) / 1082;
    $(".slide1").css({ transform: `scale(${scale})` });
    $(".slide2").css({ transform: `scale(${scale})` });
    $(".slide").css({
      bottom: "5px"
    });
  } else {
    $(".slide").css({
      bottom: 0
    });
    $(".swiper-slide").css({
      height: "1150px"
    });
    $(".slide1").css({
      height: "1150px"
    });
    $(".slide2").css({
      height: "1150px"
    });
  }
}

function setBtn() {
  setHistory();
  let btn1, btn2;
  if (_.activeIndex === 1) {
    btn1 = btn1Active;
    btn2 = btn2Deafult;
    $("#btn-1")
      .removeClass("default")
      .addClass("active");
    $("#btn-2")
      .removeClass("active")
      .addClass("default");
  } else {
    btn1 = btn1Deafult;
    btn2 = btn2Active;
    $("#btn-2")
      .removeClass("default")
      .addClass("active");
    $("#btn-1")
      .removeClass("active")
      .addClass("default");
  }
  $("#btn-1").attr("src", btn1);
  $("#btn-2").attr("src", btn2);
}

function setEvents() {
  document.querySelector("#share-mask").addEventListener("click", () => {
    $("#share-mask").css({ display: "none" });
  });

  $("#btn-1").click(() => {
    if (_.activeIndex === 1) return;
    _.activeIndex = 1;
    setSwiperData("store");

    setBtn();

    getImgs();
  });

  $("#btn-2").click(() => {
    if (_.activeIndex === 2) return;
    _.activeIndex = 2;
    setSwiperData("delivery");

    setBtn();

    getImgs();
  });
}

// 弹出键盘后归位

function setBroswerInput() {
  var originScrollTop;

  $(window).scroll(function() {
    originScrollTop = $(window).scrollTop();
  });

  // $("#brand-select").on("blur", function() {
  //   $(window).scrollTop(originScrollTop);
  // });
}

// 微信

function setWechatShareText(url) {
  wx.ready(function() {
    //自定义微信分享内容功能
    wx.onMenuShareTimeline({
      title: wechatShareText.title,
      link: wechatShareText.url,
      imgUrl: wechatShareText.imgUrl,
      success: function() {}
    });
    wx.onMenuShareAppMessage({
      title: wechatShareText.title,
      desc: wechatShareText.desc,
      link: wechatShareText.url,
      imgUrl: wechatShareText.imgUrl,
      type: "",
      dataUrl: "",
      success: function() {}
    });
  });
}

function setWxSetting() {
  $.ajax({
    method: "GET",
    url: "/88/interface/wechat.php",
    data: {
      url: encodeURIComponent(window.location.href)
    },
    success(res) {
      if (res) {
        let data = res.info;
        wx.config({
          debug: false,
          appId: "wxa8f9f84daf5e849f",
          timestamp: data.timestamp,
          nonceStr: data.noncestr,
          signature: data.signature,
          jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline"]
        });

        wechatShareText.url = data.url;

        wx.ready(function() {
          setWechatShareText();
        });
      }
    }
  });
}

function setHistory() {
  if (_.isFirst) {
    history.replaceState(
      null,
      "",
      "?activeIndex=" + _.activeIndex + "&clickIndex=" + _.clickIndex
    );
  } else {
    _.isFirst = true;
  }
}
